import "./Login.css";
import { Card } from "react-bootstrap";
import rcmlogo from "../../assets/rcmlogo.png";
import { Button, Form } from "react-bootstrap";
import { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { userlogin } from "../../core/services/authservice";
import { useAppDispatch, useAppSelector } from "../../core/redux/hooks";
import { setIsAuthenticated, setUserDetails, setStatus } from "../../core/redux/authSlice";
import { getSettingsDetails } from "../../core/services/sharedService";
import constant from "../../core/constant";
import { hideToaster, showToaster } from "../../core/redux/toastSlice";

const Login = () => {
    const [email, setEmail] = useState<any>("");
    const [password, setPassword] = useState<any>("");
    const [admin, setAdmin] = useState<any>("");
    const dispatch = useAppDispatch();
    const navigate = useNavigate();

    const [passwordType, setPasswordType] = useState<string>("password");

    const togglePassword = () => {
        if (passwordType === "password") {
            setPasswordType("text")
            return;
        }
        setPasswordType("password")
    }

    const handleChange = (e: any) => {
        const { name, value } = e.target;
        if (name === "email") {
            setEmail(value);
        }
        if (name === "password") {
            setPassword(value.trim());
        }
        if (name === "admin") {
            setAdmin(e.target.checked);
        }
    };


    const handleSubmit = (e: any) => {
        e.preventDefault();
        if (!email) {
            dispatch(showToaster(
                {
                    dialogBgColor: 'bg-danger',
                    dialogMsg: "Email is required.",
                    showDialog: true,
                    timer: '5000'
                }
            ));
            return false;
        } else {
            let pattern = new RegExp(
                /^\w+([\+\.-]?\w+)*@\w+([\+\.-]?\w+)*(\.\w{2,3})+$/
            );
            if (!pattern.test(email.trim())) {
                dispatch(showToaster(
                    {
                        dialogBgColor: 'bg-danger',
                        dialogMsg: "Invalid email format.",
                        showDialog: true,
                        timer: '5000'
                    }
                ));
                return false;
            }
        }
        if (!password) {
            dispatch(showToaster(
                {
                    dialogBgColor: 'bg-danger',
                    dialogMsg: "Password is required.",
                    showDialog: true,
                    timer: '5000'
                }
            ));
            return false;
        } else {
            if (
                !password.trim().match(
                    /^.*(?=.{8,})(?=.*\d)(?=.*[a-z])(?=.*[A-Z])(?=.*[@#$%&!]).*$/
                )
            ) {
                dispatch(showToaster(
                    {
                        dialogBgColor: 'bg-danger',
                        dialogMsg: "Invalid password format.",
                        showDialog: true,
                        timer: '5000'
                    }
                ));
                return false;
            }
        }
        login(email, password);
    };

    const login = (email: any, password: any) => {
        if (email && password) {
            userlogin(email?.toLowerCase().trim(), password.trim(), admin)
                .then((response: any) => {
                    if (
                        response &&
                        response.accessToken &&
                        response.accessToken ===
                        localStorage.getItem("access_Token")
                    ) {
                        dispatch(hideToaster());
                        dispatch(setIsAuthenticated(true));
                        if (!admin) {
                            dispatch(setUserDetails(response.agent));
                            localStorage.setItem('event', process.env.REACT_APP_AGENT ? process.env.REACT_APP_AGENT : '');
                            navigate("/dashboard");

                            // const socket = websocketConnection;
                            // socket.on('connect', () => {
                            //     socket.emit('agent_connect', async(res:any)=>{});
                            //     dispatch(setStatus(true));
                            // });
                            // socket.on('disconnect', () => {
                            //     dispatch(setStatus(false));
                            // });

                        } else {
                            dispatch(setUserDetails(response.user));
                            localStorage.setItem('event', process.env.REACT_APP_ADMIN ? process.env.REACT_APP_ADMIN : '');
                            getSettingsDetails();
                            navigate(constant.AGENT_CREATE);
                        }
                    }
                })
                .catch((error: any) => {
                    dispatch(showToaster(
                        {
                            dialogBgColor: 'bg-danger',
                            dialogMsg: error.response.data.message ? error.response.data.message : "Something went wrong",
                            showDialog: true,
                            timer: '5000'
                        }
                    ));
                });
        } else {
            dispatch(showToaster(
                {
                    dialogBgColor: 'bg-danger',
                    dialogMsg: "Email and password is required.",
                    showDialog: true,
                    timer: '5000'
                }
            ));
        }
    };

    return (
        <>
            <div className="container-fluid unauth" style={{height:'100vh'}}>
                <div className="row h-100 d-flex align-items-center justify-content-center">
                    <div className="col-12 col-lg-6 h-100 d-flex align-items-center justify-content-center left">
                        <Card.Img
                            src={rcmlogo}
                            alt="Card image"
                            className="rcmlogo"
                        />
                    </div>
                    <div className="col-12 col-lg-6 h-100 d-flex align-items-center justify-content-center flex-column  gap-5 right">
                    <Card.Img
                            src={rcmlogo}
                            alt="Card image"
                            className="rcmlogo d-block d-lg-none"
                        />
                        <Form onSubmit={handleSubmit}>
                            <div className="m-3">
                                <div>
                                    <label>Email</label>
                                </div>
                                <div className='input-group'>
                                    <input
                                        type="text"
                                        name="email"
                                        onChange={handleChange}
                                        className="form-control input-textgenere"
                                    />
                                </div>
                            </div>
                            <div className="m-3">
                                <div>
                                    <label>Password</label>
                                </div>
                                <div className="input-group">
                                    <input type={passwordType} name="password" onChange={handleChange} className="form-control input-textgenere" />
                                    <div className="input-group-append">
                                        <button className="btn btn-outline-primary" type="button" onClick={togglePassword}>
                                            {passwordType === "password" ? <i className="bi bi-eye-slash"></i> : <i className="bi bi-eye"></i>}
                                        </button>
                                    </div>
                                </div>
                            </div>
                            <div className="m-3">
                                <div className="row">
                                    <div className="col-md-6 ml-4">
                                        <input
                                            type="checkbox"
                                            name="admin"
                                            className="form-check-input"
                                            onChange={handleChange}
                                        />
                                        &nbsp;&nbsp;&nbsp;&nbsp;
                                        <label>Login As Admin</label>
                                    </div>
                                </div>
                            </div>
                            <div className="login-action-info">
                                    <Button
                                        style={{ backgroundColor: '#62bb46',
                                            border: 'none',
                                            padding: '10px 25px',}}
                                        type="submit"
                                        onClick={handleSubmit}
                                        className="m-3"
                                    >
                                        Login
                                    </Button>
                                    <Link
                                        to="/resetpassword"
                                        className="link-text"
                                    >
                                        Reset Your Password
                                    </Link>
                            </div>
                        </Form>
                    </div>
                </div>
            </div>

        </>
    );
};

export default Login;
